import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import Item from "./Temporary/Item";
import History from "../../../../../features/TraxxionProfile/sections/Availability/components/History";
import { pickIntervals } from "./helpers";
import { weekdays } from "../../../inputs/WeekdaySelect/types";
import { firstToUpper } from "../../../../../utils/helpers/string";

function Recurring({ query }: any) {
    const { t } = useTranslation();
    const firstDay = moment.localeData().firstDayOfWeek();
    const orderedWeekdays = [...weekdays.slice(firstDay), ...weekdays.slice(0, firstDay)];

    const days = useMemo(() => {
        const entries: any[] = Array.isArray(query?.data) ? query.data : [];
        return entries.reduce((total: Record<string, any[]>, entry) => {
            if (!entry?.day) return total;
            return { ...total, [entry.day]: [...(total[entry.day] || []), entry] };
        }, {});
    }, [query?.data]);

    return (
        <div className="tw-space-y-2">
            {orderedWeekdays.map((day: any) => {
                const entries: any[] = days[day] || [];

                const visible = entries
                    .filter((entry) => entry.status === "pending" || entry.status === "approved")
                    .sort((a, b) => moment(a.startDate).diff(moment(b.startDate)));

                const history = entries.flatMap((entry) => entry.history || []);
                const showPeriod = visible.length > 1;

                return (
                    <div key={day} className="tw-border tw-rounded-xl tw-px-4 tw-py-3 tw-flex tw-items-center tw-gap-4">
                        <div className="tw-shrink-0 tw-w-24">
                            <p className="tw-text-sm tw-font-medium">{firstToUpper(t(day))}</p>
                        </div>

                        <div className="tw-flex-1 tw-min-w-0">
                            {visible.length > 0 ? (
                                visible.map((entry, index) => (
                                    <Item
                                        key={entry.id || index}
                                        index={index}
                                        item={{
                                            status: entry.status,
                                            allDay: entry.allDay,
                                            isAvailable: entry.isAvailable,
                                            reason: entry.reason,
                                            shifts: pickIntervals(entry.intervals, entry.isAvailable ?? true),
                                            period: showPeriod ? { startDate: entry.startDate, endDate: entry.endDate } : undefined,
                                        }}
                                    />
                                ))
                            ) : (
                                <p className="tw-text-sm tw-text-muted-foreground tw-m-0">{t("not-set")}</p>
                            )}
                        </div>

                        {history.length > 0 && (
                            <div className="tw-shrink-0 tw-self-start tw-pt-1">
                                <History title={firstToUpper(t(day))} history={history} />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

export default Recurring;
